module.exports = __webpack_public_path__ + "img/lasource-9.90e36bf6.jpg";